import {
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  makeStyles,
  Switch,
  Typography,
} from "@material-ui/core";
import { useField, useFormikContext } from "formik";

const useStyles = makeStyles({
  switchBase: {
    "&$checked": {
      color: "#FFFFFF",
      "& + $track": {
        backgroundColor: "#FFD140",
        opacity: 1,
      },
    },
  },
  checked: {},
  track: {
    backgroundColor: "#bdbdbd",
  },
});

export function SwitchField({ label, disabled, ...props }) {
  const [field] = useField(props);
  const { isSubmitting } = useFormikContext();

  return (
    <FormControlLabel
      control={<Switch color="default" checked={field.value} {...props} {...field} />}
      label={label}
      disabled={disabled || isSubmitting}
    />
  );
}

// TODO TASK: refactor this component to be able customizing label and description for left and right switch, this component can used in setting page
export function CustomSwitchField({
  leftLabel = null,
  leftDescription = null,
  rightLabel = null,
  rightDescription = null,
  disabled,
  ...props
}) {
  const classes = useStyles();

  const [field, meta, helpers] = useField(props);
  const { isSubmitting } = useFormikContext();

  // ensure the value is always boolean
  const checked = Boolean(field.value);

  const handleChange = (e) => {
    helpers.setValue(e.target.checked);
    // helpers.setTouched(true);
  };

  const hasDescription = leftDescription || rightDescription;

  return (
    <FormControl error={meta.touched && Boolean(meta.error)} component="fieldset">
      <FormGroup
        row
        style={{
          // display: "flex",
          // flexDirection: "row",
          alignItems: hasDescription ? "flex-start" : "center",
          gap: 8,
          flexWrap: "nowrap",
          opacity: disabled || isSubmitting ? 0.5 : 1,
        }}
      >
        {/* Left Side */}
        {(leftLabel || leftDescription) && (
          <Box
            display="flex"
            flexDirection="column"
            // mt={hasDescription ? 1 : 0}
            style={{ opacity: !checked ? 1 : 0.4 }}
          >
            {leftLabel && (
              <Typography variant="subtitle1" style={{ lineHeight: 1.2 }}>
                {leftLabel}
              </Typography>
            )}
            {leftDescription && (
              <Typography variant="caption" color="textSecondary" style={{ marginTop: 4 }}>
                {leftDescription}
              </Typography>
            )}
          </Box>
        )}

        {/* The Switch */}
        <Switch
          color="default"
          checked={checked}
          onChange={handleChange}
          disabled={disabled || isSubmitting}
          classes={{
            switchBase: classes.switchBase,
            checked: classes.checked,
            track: classes.track,
          }}
          {...field}
          {...props}
        />

        {/* Right Side */}
        {(rightLabel || rightDescription) && (
          <Box
            display="flex"
            flexDirection="column"
            // mt={hasDescription ? 1 : 0}
            style={{ opacity: checked ? 1 : 0.4 }}
          >
            {rightLabel && (
              <Typography variant="subtitle1" style={{ lineHeight: 1.2 }}>
                {rightLabel}
              </Typography>
            )}
            {rightDescription && (
              <Typography variant="caption" color="textSecondary" style={{ marginTop: 4 }}>
                {rightDescription}
              </Typography>
            )}
          </Box>
        )}
      </FormGroup>
      {meta.touched && meta.error && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
}
